import { configureStore } from "@reduxjs/toolkit";
import AuthSlice from "./Auth/AuthSlice";
import appSlice from "./CommonApp/appSlice";
import userByTypeSlice from "./User/userByTypeSlice";

export const store = configureStore({
  reducer: {
    auth: AuthSlice,
    app: appSlice,
    user: userByTypeSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
